import { render, staticRenderFns } from "./CopyModal.vue?vue&type=template&id=09be25c0&scoped=true"
import script from "./CopyModal.vue?vue&type=script&lang=js"
export * from "./CopyModal.vue?vue&type=script&lang=js"
import style0 from "./CopyModal.vue?vue&type=style&index=0&id=09be25c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09be25c0",
  null
  
)

export default component.exports